<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="unAt2tYZfDys5tSPYYdTaQG">
<p class="Normal ParaOverride-6"><span class="CharOverride-6">Dedicated to those of us who were </span></p>
<p class="Normal ParaOverride-6"><span class="CharOverride-2">taught to feel afraid.</span></p>
<p class="Normal ParaOverride-6"><span class="CharOverride-2">WE ARE</span></p>
<p class="Normal ParaOverride-6"><span class="CharOverride-2">More than a slur spoken in passing.</span></p>
<p class="Normal ParaOverride-6"><span class="CharOverride-2">More than an object of illicit desire.</span></p>
<p class="Normal ParaOverride-6"><span class="CharOverride-2">More than a way to vent their anger.</span></p>
<p class="Normal ParaOverride-6"><span class="CharOverride-2">We are deserving of protection.</span></p>
<p class="Normal ParaOverride-6"><span class="CharOverride-2">AND THEIR GAZE CANNOT DIMINISH US.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// stsebastianepub_split3.vue?17f5c63c